export const PRODUCTION = process.env.NODE_ENV === 'production';
export const DEVELOPMENT = process.env.NODE_ENV === 'development';
export const APP_VERSION = process.env.VERSION;

export const FEEDBACK_EMAIL = process.env.MAILTO || 'support@mstryshk.in';
